export default "__VITE_ASSET__CrGk4q6Z__"